(() => {
  const money = (cents) =>
    new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
    }).format(cents / 100);

  /* ---------- Mobile menu ---------- */
  const menu = document.getElementById('MobileMenu');
  const openBtn = document.querySelector('[data-menu-open]');
  const closeBtn = document.querySelector('[data-menu-close]');
  const setMenu = (open) => {
    if (!menu) return;
    menu.hidden = !open;
    menu.dataset.open = String(open);
    openBtn?.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    (open ? closeBtn : openBtn)?.focus();
  };
  openBtn?.addEventListener('click', () => setMenu(true));
  closeBtn?.addEventListener('click', () => setMenu(false));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu && !menu.hidden) setMenu(false);
  });

  /* ---------- Age gate ---------- */
  const gate = document.getElementById('AgeGate');
  if (gate) {
    gate.querySelector('[data-age-yes]')?.addEventListener('click', () => {
      try {
        localStorage.setItem('easeup-age-verified', 'yes');
      } catch (e) {}
      gate.hidden = true;
      document.body.style.overflow = '';
    });
    gate.querySelector('[data-age-no]')?.addEventListener('click', () => {
      const exit = gate.dataset.exitUrl;
      if (exit) {
        window.location.href = exit;
        return;
      }
      gate.querySelector('[data-age-ask]').hidden = true;
      gate.querySelector('[data-age-denied]').hidden = false;
    });
  }

  /* ---------- Product page: variant picker ---------- */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const button = form.querySelector('[data-add-button]');
    const price = document.querySelector('[data-price]');
    form.querySelectorAll('input[type="radio"][name="id"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const available = radio.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? `Add to cart · ${radio.dataset.price}` : 'Sold out';
        if (price) price.textContent = radio.dataset.price;
        const compare = document.querySelector('[data-compare]');
        const save = document.querySelector('[data-save]');
        if (compare) {
          compare.textContent = radio.dataset.compare || '';
          compare.hidden = !radio.dataset.compare;
          if (save) save.hidden = !radio.dataset.compare;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });
  });

  /* ---------- Product page: subscription (selling plan) options ---------- */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const box = form.querySelector('[data-purchase-options]');
    if (!box) return;
    const prices = JSON.parse(form.querySelector('[data-plan-prices]').textContent);
    const hidden = box.querySelector('[data-selling-plan]');
    const button = form.querySelector('[data-add-button]');
    const priceEl = document.querySelector('[data-price]');
    const variantId = () => (form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]')).value;
    const refresh = () => {
      const plan = (box.querySelector('input[name="purchase_option"]:checked') || {}).value || '';
      hidden.value = plan;
      hidden.disabled = !plan;
      const vp = prices[variantId()] || {};
      box.querySelectorAll('[data-po-price]').forEach((el) => {
        const p = vp[el.dataset.poPrice];
        if (p) el.textContent = p;
      });
      const p = vp[plan] || vp[''];
      if (!button.disabled && p) {
        button.textContent = (plan ? 'Subscribe · ' : 'Add to cart · ') + p;
        if (priceEl) priceEl.textContent = p;
      }
    };
    box.querySelectorAll('input[name="purchase_option"]').forEach((r) => r.addEventListener('change', refresh));
    form.querySelectorAll('input[name="id"]').forEach((r) => r.addEventListener('change', () => setTimeout(refresh)));
    refresh();
  });

  /* ---------- Product page: photo thumbnails + quantity stepper ---------- */
  const mainImg = document.querySelector('[data-pdp-main] img');
  document.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImg) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = thumb.dataset.src;
      mainImg.alt = thumb.dataset.alt;
      document.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', t === thumb));
      // The first photo is the transparent can; the rest are regular photos shown upright in a card.
      const index = [...document.querySelectorAll('[data-thumb]')].indexOf(thumb);
      mainImg.closest('[data-pdp-main]').classList.toggle('is-photo', index > 0);
    });
  });
  document.querySelectorAll('.qty-stepper').forEach((stepper) => {
    const input = stepper.querySelector('input');
    stepper.querySelectorAll('[data-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        input.value = Math.min(50, Math.max(1, Number(input.value || 1) + Number(btn.dataset.step)));
      });
    });
  });

  /* ---------- Best sellers cards: pack chips update price/button ---------- */
  document.querySelectorAll('[data-best-form]').forEach((form) => {
    const label = form.querySelector('[data-best-label]');
    const price = form.querySelector('[data-best-price]');
    const button = form.querySelector('[data-best-add]');
    form.querySelectorAll('input[type="radio"][name="id"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const ok = radio.dataset.available === 'true';
        button.disabled = !ok;
        label.textContent = ok ? 'Add to cart' : 'Sold out';
        price.textContent = radio.dataset.price;
      });
    });
  });

  /* ---------- Add to cart without leaving the page ---------- */
  const updateCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
    document.querySelectorAll('.cart-link').forEach((el) => {
      el.setAttribute('aria-label', `Cart, ${count} item${count === 1 ? '' : 's'}`);
    });
  };

  document.querySelectorAll('.js-add-form').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const status = form.querySelector('.form-status');
      const button = form.querySelector('[type="submit"]');
      const label = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
        const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
        updateCount(cart.item_count);
        if (status) {
          status.className = 'form-status ok';
          status.innerHTML = 'Added to your cart. <a href="/cart">View cart &rarr;</a>';
          status.hidden = false;
        }
      } catch (err) {
        if (status) {
          status.className = 'form-status err';
          status.textContent = err.message;
          status.hidden = false;
        }
      } finally {
        button.disabled = false;
        button.innerHTML = label;
      }
    });
  });

  /* ---------- Cart page: +/- buttons submit the cart form ---------- */
  const cartForm = document.getElementById('CartForm');
  if (cartForm) {
    let timer;
    const submitSoon = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const update = document.createElement('input');
        update.type = 'hidden';
        update.name = 'update';
        update.value = '1';
        cartForm.appendChild(update);
        cartForm.submit();
      }, 400);
    };
    cartForm.querySelectorAll('[data-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = document.getElementById(btn.dataset.qtyTarget);
        const next = Math.min(50, Math.max(0, Number(input.value) + Number(btn.dataset.qtyStep)));
        input.value = next;
        submitSoon();
      });
    });
    cartForm.querySelectorAll('.qty-input').forEach((input) => input.addEventListener('change', submitSoon));
  }

  /* ---------- Store locator filter ---------- */
  document.querySelectorAll('[data-locator]').forEach((root) => {
    const cards = [...root.querySelectorAll('.loc-card')];
    const chips = [...root.querySelectorAll('.loc-chip')];
    const pins = [...root.querySelectorAll('.loc-pin')];
    const heading = root.querySelector('[data-locator-heading]');
    const count = root.querySelector('[data-locator-count]');
    let current = 'all';
    const apply = (city) => {
      current = city;
      let n = 0;
      cards.forEach((c) => {
        const show = city === 'all' || c.dataset.city === city;
        c.hidden = !show;
        if (show) n++;
      });
      chips.forEach((c) => {
        const on = c.dataset.city === city;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', String(on));
      });
      pins.forEach((p) => p.classList.toggle('is-on', p.dataset.city === city));
      const chip = chips.find((c) => c.dataset.city === city);
      heading.textContent = city === 'all' ? 'All locations' : chip.firstChild.textContent.trim();
      count.textContent = n + (n === 1 ? ' store' : ' stores');
    };
    const wrap = root.querySelector('.locator-map-wrap');
    const fit = () => { if (wrap) wrap.style.setProperty('--map-scale', String(wrap.clientWidth / 620)); };
    fit();
    window.addEventListener('resize', fit);
    chips.forEach((c) => c.addEventListener('click', () => apply(c.dataset.city)));
    pins.forEach((p) => p.addEventListener('click', () => apply(current === p.dataset.city ? 'all' : p.dataset.city)));
  });

  /* ---------- Testimonial carousel ---------- */
  document.querySelectorAll('[data-carousel]').forEach((root) => {
    const slides = [...root.querySelectorAll('[data-slide]')];
    if (slides.length < 2) return;
    let i = 0;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, j) => (s.hidden = j !== i));
    };
    root.querySelector('[data-prev]')?.addEventListener('click', () => show(i - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => show(i + 1));
  });

  window.EaseUp = { money };
})();
